
<div class="card-container ciclo-escolar">
    <mat-card class="example-card">
        <mat-card-header>
            <mat-card-title>Gestor de planes de estudio</mat-card-title>
            <mat-card-subtitle>Gestión y control de curricula escolar</mat-card-subtitle>
        </mat-card-header>
    </mat-card>
</div>

